import { Noun } from '../../types'

const хуй: Noun = {
  type: 'noun',
  nominativeSingular: 'хуй',
  genitiveSingular: 'хуя',
  dativeSingular: 'хую',
  accusativeSingular: 'хуй',
  instrumentalSingular: 'хуём',
  prepositionalSingular: 'хуе',
  nominativePlural: 'хуи',
  genitivePlural: 'хуёв',
  dativePlural: 'хуям',
  accusativePlural: 'хуи',
  instrumentalPlural: 'хуями',
  prepositionalPlural: 'хуях',
}

export default хуй
